import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DefaultDataService, HttpUrlGenerator, QueryParams } from '@ngrx/data';
import { Observable, of, switchMap, filter } from 'rxjs';
import { HelperService } from 'src/app/service/helper.service';
import { EndPoints, UrlProviderService } from 'src/app/service/urlprovider.service';
import { School } from '../../../model/school.model';
import { Region } from '../../../model/region.model';
import { MsgModel } from '../msg/model/msg.model';

@Injectable({
    providedIn: 'root'
})
export class SchoolDataService extends DefaultDataService<School> {
    constructor(http: HttpClient, httpUrlGenerator: HttpUrlGenerator, public urlProvider: UrlProviderService, private helperService: HelperService) {
        super('School', http, httpUrlGenerator);

        super.add;
    }

    override getAll(): Observable<School[]> {
        const url = this.urlProvider.getUrl(EndPoints.school_indexSchools, undefined, undefined);
        let lstRegion: Region[] = [];
        this.helperService.lstRegion$.subscribe((x) => {
            lstRegion = x;
        });

        return this.http
            .post(
                url,
                { regions: lstRegion, openSchoolsOnly: true },
                (Headers = {
                    ...this.urlProvider.baseGetOptions()
                })
            )
            .pipe(
                switchMap((res: any) => {
                    return of(<School[]>JSON.parse(res.body['schools']));
                })
            );
    }

    override getWithQuery(queryParams: QueryParams | string): Observable<School[]> {
        const url = this.urlProvider.getUrl(EndPoints.school_indexSchools, undefined, undefined);
        // let lstRegion: Region = {};
        // this.helperService.lstRegion$.subscribe({
        //     next: (regions: any) => {
        //         lstRegion = regions.filter((r: Region) => r.ID === parseInt('18'));
        //     },
        //     error: (err) => {},
        //     complete: () => {}
        // });

        let params: any = { openSchoolsOnly: false };
        if (typeof queryParams === 'object') {
            for (var property in queryParams) {
                if (Object.prototype.hasOwnProperty.call(queryParams, property)) {
                    params[property] = [];

                    if (Array.isArray(queryParams[property])) {
                        const arr: any = queryParams[property];

                        arr.forEach((parameter: string) => {
                            params[property].push({ ID: parameter });
                        });
                    }
                    else
                    {
                        params[property] = queryParams[property];
                    }
                }
            }
        }

        return this.http
            .post(
                url,
                params,
                (Headers = {
                    ...this.urlProvider.baseGetOptions()
                })
            )
            .pipe(
                switchMap((res: any) => {
                    if (res.body['schools']) {
                        return of(<School[]>JSON.parse(res.body['schools']));
                    } else {
                        return of(<School[]>[]);
                    }
                })
            );
    }
}
